import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./MyLearningPath.css";
import course1 from "../../images/lp.png";
import { apiFetch } from '../../utils/api';

const MyLearningPath = () => {
  const navigate = useNavigate();
  const [learningPaths, setLearningPaths] = useState([]);
  const [loading, setLoading] = useState(true);


  useEffect(() => {
    const userEmail = localStorage.getItem('userEmail');
    apiFetch(`${window._env_.API_BASE_URL}/user_learning_paths/my-learning-paths?user_email=${encodeURIComponent(userEmail)}`)
      .then((data) => {
        setLearningPaths(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching my learning paths:", error);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="umlp-loading">Loading...</div>;
  }

  if (!learningPaths || learningPaths.length === 0) {
    return (
      <div className="umlp-learning-paths-container">
        <h1 className="umlp-title">My Learning Paths</h1>
        <p className="umlp-subtitle">
          Track your progress across structured learning journeys
        </p>
        <div className="umlp-empty-state">
          You have not been assigned any learning paths
        </div>
      </div>
    );
  }

  return (
    <div className="umlp-learning-paths-container">
      <h1 className="umlp-title">My Learning Paths</h1>
      <p className="umlp-subtitle">
        Track your progress across structured learning journeys
      </p>

      <div className="umlp-grid">
        {learningPaths.map((path) => (
          <div key={path.id} className="umlp-card">
            <img src={course1} alt={path.title} className="umlp-card-image" />

            <div className="umlp-card-content">
              <h2 className="umlp-card-title">{path.title}</h2>
              <div className="umlp-details">
                <p>Total Credits: {path.credits}</p>
                <p>Total Courses: {path.courses}</p>
                <p>Total Duration: {path.duration}</p>
              </div>

              <div className="umlp-progress-section">
                <p>Progress</p>
                <div className="umlp-progress-bar">
                  <div
                    className="umlp-progress-fill"
                    style={{ width: `${path.progress}%` }}
                  ></div>
                </div>
                <p className="umlp-progress-text">{path.progress}%</p>
              </div>

              <button
                className="umlp-view-btn"
                onClick={() =>
                  navigate(`/my-courses/mylearningpath/learningpathdetail/${path.id}`)
                }
              >
                View Path
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MyLearningPath;